//     Basic usage
//    <Tag>Testing</Tag>
//    <Tag variant="secondary">Testing</Tag>
//    <Tag size='sm' variant="gradient">Testing</Tag>
//    <Tag size='responsive' variant="primary">Testing</Tag>

const variants = {
  defaultClassName: `
    shrink-0 select-none relative inline-flex justify-center items-center font-extrabold rounded-full
  `,
  variant: {
    default: `
      bg-default-200 text-default-500
    `,
    primary: `
      bg-primary-500 text-default-50
    `,
    secondary: `
      bg-primary-900 text-default-50
    `,
    gradient: `
      bg-green-1 text-default-50
    `
  },
  size: {
    sm: 'px-3 pt-1 pb-1 text-[9px]',
    base: 'px-3 pt-1 pb-1.5 text-xs',
    responsive: 'px-3 pt-1 pb-1 md:pb-1.5 text-[9px] md:text-xs '
  },
  mobile: {
    default: '',
    block: 'w-full'
  }
}

export const Tag = (props) => {
  const {
    children,
    variant = 'default',
    size = 'base',
    mobile = 'default',
    className = ''
  } = props

  const combinedClassName = `
    ${variants.defaultClassName}
    ${variants.variant[variant] || variants.variant.primary}
    ${variants.size[size] || variants.size.base}
    ${variants.mobile[mobile] || variants.mobile.default}
    ${className}
  `.trim().replace(/\s+/g, ' ')

  return (
    <span
      {...props}
      className={combinedClassName}
    >
      {children}
    </span>
  )
}
